import service from './service'
import { useUserStoreWithOut } from '@/store/modules/user'

const requestPost = (url: any, data: any, type: any) => {
  const userStore = useUserStoreWithOut()
  return service.request({
    url: url,
    method: 'post',
    data,
    headers: {
      'Content-Type':
        type === 'json'
          ? 'application/json'
          : type === 'form'
            ? 'multipart/form-data'
            : 'application/x-www-form-urlencoded',
      stoken: userStore.getToken ?? '',
      appcode: 'rsadmin'
    }
  })
}
const requestGet = (url: any, data: any, type: any) => {
  const userStore = useUserStoreWithOut()
  return service.request({
    url: url,
    method: 'get',
    data,
    headers: {
      'Content-Type':
        type === 'json'
          ? 'application/json'
          : type === 'form'
            ? 'multipart/form-data'
            : 'application/x-www-form-urlencoded',
      stoken: userStore.getToken ?? '',
      appcode: 'rsadmin'
    }
  })
}

export default {
  get: (url: any, data = {}, type = 'json') => {
    return requestGet(url, data, type)
  },
  post: (url: any, data = {}, type = 'json') => {
    return requestPost(url, data, type)
  }
}
